import { render, staticRenderFns } from "./aigcTask.vue?vue&type=template&id=77f8f342&"
import script from "./aigcTask.vue?vue&type=script&lang=js&"
export * from "./aigcTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports